import styled from 'styled-components'
// views
import { EditIcon } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view' // theme
import { colors } from 'themes/index'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  padding: 16px;

  ${EditIcon} {
    path {
      fill: ${colors.blue300};
    }
  }

  > :last-child {
    margin-top: auto;
  }
`

export const FieldsSection = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 4px;

  > div {
    flex: 1;
  }
`

export const Link = styled('a')`
  color: ${colors.blue300};
  text-decoration: none;
  font-size: 16px;
  width: max-content;

  &:hover {
    opacity: 0.8;
  }
`
